<template>
  <div class="md-layout">
    <div class="spaces md-layout-item md-size-30">
      <listFamily
        :loading="loading"
        :catalogs="catalogs"
        @family="filterSubFamily"
        @setLoading="(value) => (loading = value)"
      ></listFamily>
    </div>
    <div class="spaces md-layout-item md-size-30">
      <listSubFamily
        :familyId="idFamily"
        :loading="loading"
        :catalogs="catalogs"
        @subFamily="filterSupplys"
        @setLoading="(value) => (loading = value)"
      ></listSubFamily>
    </div>
    <div class="spaces md-layout-item md-size-40">
      <list-supplies
        :familyId="idFamily"
        :subFamilyId="idSubFamily"
        :loading="loading"
        :catalogs="catalogs"
        @setLoading="(value) => (loading = value)"
      />
    </div>
  </div>
</template>

<script>
import listFamily from "./ListFamily";
import listSubFamily from "./ListSubFamily";
import ListSupplies from "./ListSupplies";

import dataService from "@/services/catalog";

export default {
  props: {},
  components: {
    listFamily,
    ListSupplies,
    listSubFamily,
  },
  data() {
    return {
      item: {},
      classicModal: false,
      idFamily: 0,
      idSubFamily: 0,
      loading: true,

      providers: [],
      highways: [],
      unitMeasurements: [],
      supplyTypes: [],
    };
  },
  methods: {
    // Modal
    filterSubFamily(idfaily) {
      this.idFamily = idfaily;
    },
    filterSupplys(idSupp) {
      this.idSubFamily = idSupp;
    },
  },

  computed: {
    catalogs() {
      return {
        providers: this.providers,
        highways: this.highways,
        unitMeasurements: this.unitMeasurements,
        supplyTypes: this.supplyTypes,
      };
    },
  },

  mounted() {
    Promise.all([
      dataService.fetch("providers", { noStore: true }),
      dataService.fetch("highway/camp", { noStore: true }),
      dataService.fetch("common/unit_measurement", { noStore: true }),
      dataService.fetch("services/supplytype", { noStore: true }),
      dataService.fetch("services/supplies", { useStore: true }),
    ])
      .then(([providers, highways, units, types]) => {
        this.providers = providers;
        this.highways = highways;
        this.unitMeasurements = units;
        this.supplyTypes = types.sort((a, b) => (a.name < b.name ? -1 : 1));
      })
      .catch(this.$fireErrorResponse)
      .finally(() => (this.loading = false));
  },
};
</script>
<style scoped lang="scss">
.spaces {
  margin-top: -40px;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Catalogs/Supplies/Existence/index.vue